import { STORAGE_KEY, STORAGE_UPDATE_EVENT_TYPE } from './internal/constants';

export default function removePasswordSetupDetailsFromSession() {
  sessionStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new Event(STORAGE_UPDATE_EVENT_TYPE));
}
